module.exports = __webpack_public_path__ + "img/add-picture.aeecc9ee.svg";